<template>
  <div class="landing-view">
    <section class="info">
      <h1 class="section-title">Gabon virtual deal room</h1>
      <p>
        Gabon has made private investment a key lever to diversify and transform
        its economy under the Transformation Acceleration Plan (PAT). This
        virtual deal room provides investors with reliable and up-to-date
        information on investment projects from the government and the private
        sector to encourage private investors to seize the many business
        opportunities in Gabon.
      </p>
    </section>

    <section class="benefits-section mt-20">
      <div class="benefit-wrap">
        <h5 class="benefit-label" style="--color: #ffffff">
          For investors looking <b>to invest in Africa:</b>
        </h5>
        <div class="benefits-card card justify-content-between">
          <div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>Screen for deals aligned with your investment interests</p>
              </div>
            </div>
            <div class="separator separator-dashed border-primary my-3"></div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>Get notified of new deals that meet your criteria</p>
              </div>
            </div>
            <div class="separator separator-dashed border-primary my-3"></div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>
                  Receive support from dedicated deal team help you deploy
                  capital in Gabon
                </p>
              </div>
            </div>
          </div>
          <router-link
            :to="{ name: 'sign-up' }"
            class="btn btn-primary mt-10"
            style="background: #1d4f91"
            @click="setPrimaryRole('investor')"
          >
            Review deals
          </router-link>
        </div>
      </div>

      <div class="benefit-wrap mx-5">
        <h5 class="benefit-label" style="--color: #ffffff">
          For African companies <b>seeking funding:</b>
        </h5>
        <div class="benefits-card card justify-content-between">
          <div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>Provide deals for promotion here</p>
              </div>
            </div>
            <div class="separator separator-dashed border-primary my-3"></div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>Personal attention from VDR support team</p>
              </div>
            </div>
            <div class="separator separator-dashed border-primary my-3"></div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>Connect with broad range international investors</p>
              </div>
            </div>
          </div>
          <a
            href="mailto:dealroom@asokoinsight.com"
            class="btn btn-primary mt-10"
            style="background: #1d4f91"
            @click="setPrimaryRole('investee')"
          >
            Deal Room
          </a>
        </div>
      </div>

      <div class="benefit-wrap">
        <h5 class="benefit-label" style="--color: #ffffff">
          For intermediaries looking <b>to support deal making:</b>
        </h5>
        <div class="benefits-card card justify-content-between">
          <div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>
                  Support deal making by helping investees to get deals
                  published
                </p>
              </div>
            </div>
            <div class="separator separator-dashed border-primary my-3"></div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>Expand your services to Gabon with institutional support</p>
              </div>
            </div>
            <div class="separator separator-dashed border-primary my-3"></div>
            <div class="als-benefit">
              <img src="media/events/als/benefit.svg" alt="Als benefit" />
              <div class="benefit-caption">
                <p>Get insights, contacts and useful information</p>
              </div>
            </div>
          </div>
          <a
            href="mailto:dealroom@asokoinsight.com"
            class="btn btn-primary mt-10"
            style="background: #1d4f91"
            @click="setPrimaryRole('intermediary')"
          >
            Support deal making
          </a>
        </div>
      </div>
    </section>

    <h5 class="privacy-disclaimer">
      <inline-svg src="media/icons/custom/privacy.svg" />
      Your information is treated in confidence throughout the deal process.
    </h5>

    <section class="tabs-section">
      <h1 class="section-title text-center">Why sign up?</h1>
      <landing-tabs />
    </section>
  </div>
</template>

<script>
import LandingTabs from "../components/landing/landing-tabs.vue";

export default {
  name: "LandingView",
  components: {
    LandingTabs,
  },
  methods: {
    setPrimaryRole(role) {
      this.$store.dispatch("account/setPrimaryRole", role);
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-view {
  width: 100%;
  color: #fff;
  padding-top: 150px;
  background: linear-gradient(
      360deg,
      #1d4f91 0.2%,
      rgba(29, 79, 145, 0.78) 24.57%,
      rgba(29, 79, 145, 0.42) 123.34%
    ),
    url("/public/media/landings/gabon_landing.png");

  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position-y: center;
}
.section-title {
  color: #fff;
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 25px;
}
.info {
  text-align: center;
  p {
    max-width: 850px;
    margin: 0 auto;
    font-size: 18px;
    font-weight: 500;
    font-family: Poppins;
  }
  a {
    color: #00a3ff;
  }
}
.benefits-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.benefits-card {
  background: #fff;
  border-top: 20px solid #1d4f91;
  border-radius: 12px;
  padding: 20px;
  width: 450px;
  height: 348px;
  color: #0e3167;
  .btn {
    color: #fff;
    font-family: "Poppins";
    font-weight: 500;
    font-size: 16px;
  }
}

.als-benefit {
  display: flex;
  align-items: center;
  img {
    margin-right: 15px;
  }
  .benefit-caption {
    p {
      margin-bottom: 0px;
      align-self: center;
      font-family: "Poppins";
      font-weight: 400;
      font-size: 16px;
    }
  }
}
.separator {
  margin-left: 55px;
  max-width: 750px;
}
.tabs-section {
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1400px;
  .section-title {
    margin-bottom: 50px;
  }
}

.benefit-label {
  margin-bottom: 15px;

  font-weight: 400;
  font-size: 18px;
  color: #ffffff;

  b {
    font-weight: 600;
    border-bottom: 2px solid var(--color);
  }
}
.privacy-disclaimer {
  text-align: center;
  color: #9d0000;
  font-size: 18px;
  font-weight: 600;
  margin-top: 30px;
  svg {
    vertical-align: bottom;
    margin-right: 5px;
  }
}
</style>
